export default __webpack_public_path__ + "static/media/arrowIcon.f94fd107.svg";